import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-not-authorized',
    templateUrl: './not-authorized.component.html',
    styleUrls: ['./not-authorized.component.scss'],

    imports: [
        CommonModule,
        FormsModule,
    ],

    providers: [
    ]
})
export class NotAuthorizedComponent implements OnInit {

    constructor() {
        //
    }

    ngOnInit(): void {
        //
    }

}